import { requests } from 'common/axios';

const baseUrl = 'api/MemberEnrollment';

export const RetryEnrollmentApi = {
    LoadFailedEnrollments: (): Promise<any> => requests.get(`${baseUrl}/LoadFailedEnrollments`),
    RequeueEnrollmentProcess: (data: any): Promise<any> =>
        requests.post(`${baseUrl}/ResendEnrollmentToServiceBusQueue`, data),
};
